import { Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import SolarIcon from 'components/icons/SolarIcon';
import EToolTip from 'components/others/EToolTip';

interface ReportExportButtonProps {
    disabled?: boolean;
    onClick: () => void;
}

const ReportExportButton = ({ disabled, onClick }: ReportExportButtonProps) => {
    const { t } = useTranslation(['Reports']);

    return (
        <EToolTip title={t('export.toolHint')}>
            <span className="d-inline-block">
                <Button
                    className="fs-14 px-2 toolbar-icon-btn"
                    size="sm"
                    variant="secondary"
                    disabled={disabled}
                    aria-label={t('export.tool')}
                    onClick={(e) => {
                        e.currentTarget.blur();
                        onClick();
                    }}
                >
                    <SolarIcon name="file-earmark-excel" className="fs-14 p-0" />
                </Button>
            </span>
        </EToolTip>
    );
};

export default ReportExportButton;
